module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAQAAABu4E3oAAAAAmJLR0QA/4ePzL8AAAD+SURBVDjLY2CgAghkuM7wgWExgwCS2FuG/2D4AJsGLYZfUOnFSKIQkS8MDti0FECl/zO8J1ZLBFzLNSTRr/gcxspwBCz5k8EPxRa8gJUhnCGPQQNFDI8WE4ZihnIs8D+DMXYN7gx/4D5Bh6+wa9mHU8NfhkXYNEhg2GFEKNazwXGxF0mLAyEtB4GK5gJjA6GlF78GSbCzSlAcdge/lnygktcMbWi+UcOn5TBQwQyGq2haivFpeQlUkIkRuPvxabFhCGOoxdDym4EPv39SgEpQtdxl4CEmV5YB05QNENsSn5FBgd0AxE2DTctXYI4E5ZBq4rV4MHgzCAJTgzAuBQB/ObZzqVIt7QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/map/destination.png
// module id = D9Ls
// module chunks = 2